import React, { Component } from 'react';
import { connect } from 'dva';
import { modelUtils } from '@/utils';
import { utils_tool, component_tool, framework_tool } from '@/tool';
let { Session } = utils_tool;
import { WizTableForm, WizDataAuthSelect } from '@/containers/common'
let { WizButton, WizCard, WizAntdForm, WizCustomSteps, WizRow, WizCol,WizInput } = component_tool;
let { WizContainer } = framework_tool;
const { TextArea } = WizInput;
const { Item } = WizAntdForm
const getParamRecord = (history) => {
  let record = {};
  if (history.location) {
    if (history.location.pathname === '/workflow/auditDetail') {
      if (history.location && history.location.record) {
        record = history.location.record;
        Session.set('auditDetailInfo', record)
      } else {
        record = Session.get('auditDetailInfo') || {}
      }
    }
  }
  return record
}
class AuditDetali extends WizContainer {

  componentName = 'AuditDetali';

  constructor(props) {
    super(props);
    // let record = getParamRecord(this.props.history);
    // if(record.length <=0){
    //   record = props['auditInfo']
    // }
    this.state = {
      record: props['record'],
      list: [],
    }
  }

  propsAndStateOnChange = {
    submitAudit: this._submitAudit.bind(this),
    outComeList: this._outComeList.bind(this),
  };

  _submitAudit(nextProps, nextState) {
    let { submitAudit } = nextProps
    if (submitAudit && submitAudit['success']) {
      wizNotice.success(submitAudit['msg'])
      this.jumpPage('replace', '/workflow/procTaskTodo');
      return true
    } else {
      wizNotice.error(add && add['msg'] || '操作失败,请稍后尝试');
      return false
    }
  }

  _outComeList(nextProps, nextState) {
    let { outComeList } = nextProps;
    if (outComeList && outComeList['success']) {
      this.setState({
        list: outComeList['data'],
      });
    }
    return false
  }

  _componentDidMount() {
    this.doActions([
      {
        path: 'procTaskTodo/outComeList',
        payload: {
          key: 'outComeList',
          apiParams: {
            id: this.state.record.taskId
          }
        }
      },
    ]);
  }

  _onChange(e) {
    this.setState({
      comment: e.target.value
    })
  }

  _audit(outCome) {
    this.doAction({
      path: 'procTaskTodo/audit',
      payload: {
        key: "submitAudit",
        apiParams: {
          id: this.state.record.taskId,
          comment: this.state.comment,
          businessKey: this.state.record.businessKey,
          outCome: outCome,
        }
      }
    });
  }

  _render() {
    const { list,record } = this.state;
    return (
      <div>
        

        
        <WizRow className='audit-row-item'>
                  <WizCol className='col-item' span={2} offset={0}></WizCol>
                  <WizCol span={20}><TextArea maxLength={100} rows={6} placeholder= "请输入审批意见" onChange={this._onChange.bind(this)} /></WizCol>
                  <WizCol className='col-item' span={2} offset={0}></WizCol>
                </WizRow>
        <Item wrapperCol={{ span: 12, offset: 6 }}>
          <WizRow>
            <WizCol span={24} style={{ textAlign: 'center' }}>
              {
                list.map((val, index) => (
                  <WizButton type="primary" style={{ marginLeft: 20 }} onClick={e => this._audit(val)}>{val}</WizButton>
                ))
              }
            </WizCol>
          </WizRow>
        </Item>
      </div>
    )

  }
}

const mapStateToProps = (state, ownProps) => {

  const { procTaskTodo } = state;
  const outComeList = modelUtils.getModelEntity(procTaskTodo, "outComeList");
  const submitAudit = modelUtils.getModelEntity(procTaskTodo, "submitAudit");

  const load = modelUtils.getLoadingState(state, ['procTaskTodo']);
  return {
    outComeList,
    submitAudit,
    ...load
  }
};

export default connect(mapStateToProps)(AuditDetali)
